import React, { useContext } from "react";
import CIcon from "@coreui/icons-react";
import {
    SupportTicketPopupContext,
    GETTING_LISTEN_LAYER,
    CREATE_SUPPORT_TICKET
} from "../GetHelpLabel";
import { PUBLISHING_VERSIONS, STEP_PREVIOUS_CREATE_TICKET } from "../../../../../constants";

import TicketVideoIframe from "../TicketVideoIframe";

const GettingListenLayer3 = () => {
    const { setCurrentStep } = useContext(SupportTicketPopupContext);

    const dataVideoIframe = {
        title: `We're Here to Help!`,
        description: `Please watch the publishing/versions overview video to ensure that you fully understand the functionality.`,
        urlIframe: PUBLISHING_VERSIONS
    }

    return (
        <div className="ticket-popup-content ticket-video-content">
            <div className="btn-back-ticket">
                <CIcon icon="icon-chevron-left" width={6} />
                <span onClick={() => setCurrentStep(GETTING_LISTEN_LAYER.step1)}>
                    Back
                </span>
            </div>
            <TicketVideoIframe
                title={dataVideoIframe.title}
                description={dataVideoIframe.description}
                urlIframe={dataVideoIframe.urlIframe}
                buttonVideo={() => {
                    setCurrentStep(CREATE_SUPPORT_TICKET.step1)
                    localStorage.setItem(STEP_PREVIOUS_CREATE_TICKET, GETTING_LISTEN_LAYER.step3)
                }}
            />
        </div>
    );
};

export default GettingListenLayer3;
